import { Outlet, useLocation } from 'react-router-dom';
import Header from '@components/layout/Header';
import Footer from '@components/layout/Footer';
import VfxOverlay from '@components/ui/VfxOverlay';

const MainLayout = () => {
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    return (
        <div className="min-h-screen flex flex-col relative">
            <VfxOverlay />
            <Header />
            <main className={`flex-grow relative z-10 ${!isHomePage ? 'pt-28 md:pt-32' : ''}`}>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default MainLayout;
